import React, { useState } from 'react';
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  TextInput,
  Platform,
  Linking,
} from 'react-native';
import { useNavigation } from '@react-navigation/native';

const DeleteAccountScreen = () => {
  const navigation = useNavigation();
  const [email, setEmail] = useState('');
  const [fullName, setFullName] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleDeleteRequest = () => {
    if (!email || !fullName) {
      if (Platform.OS === 'web') {
        console.warn('Por favor, preencha todos os campos.');
      } else {
        alert('Por favor, preencha todos os campos.');
      }
      return;
    }

    const subject = 'Solicitação de Exclusão de Conta';
    const body = `Solicito a exclusão da minha conta Velox.\n\nDados:\nNome completo: ${fullName}\nEmail: ${email}\n\nConforme solicitado, estou ciente de que minha conta será excluída em até 7 dias.`;

    const mailtoURL = `mailto:veloxplanaltina@gmail.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

    Linking.openURL(mailtoURL)
      .then(() => {
        setSubmitted(true);
      })
      .catch(() => {
        if (Platform.OS === 'web') {
          console.warn('Não foi possível abrir o app de e-mail.');
        } else {
          alert('Não foi possível abrir o app de e-mail.');
        }
      });
  };

  return (
    <View style={styles.container}>
      {!submitted ? (
        <>
          <Text style={styles.title}>Quer excluir sua conta Velox?</Text>

          <TextInput
            style={styles.input}
            placeholder="Digite seu e-mail"
            placeholderTextColor="#ccc"
            value={email}
            onChangeText={setEmail}
            keyboardType="email-address"
            autoCapitalize="none"
          />

          <TextInput
            style={styles.input}
            placeholder="Digite seu nome completo"
            placeholderTextColor="#ccc"
            value={fullName}
            onChangeText={setFullName}
          />

          <TouchableOpacity style={styles.deleteButton} onPress={handleDeleteRequest}>
            <Text style={styles.deleteButtonText}>Solicitar exclusão de conta</Text>
          </TouchableOpacity>

          <TouchableOpacity style={styles.cancelButton} onPress={() => navigation.goBack()}>
            <Text style={styles.cancelButtonText}>Cancelar</Text>
          </TouchableOpacity>
        </>
      ) : (
        <View style={styles.confirmation}>
          <Text style={styles.confirmationTitle}>Solicitação enviada!</Text>
          <Text style={styles.confirmationText}>
            Sua conta será excluída em até 7 dias. Verifique seu e-mail.
          </Text>
          <TouchableOpacity
            style={styles.backButton}
            onPress={() => navigation.replace('LoginScreen')}
          >
            <Text style={styles.backButtonText}>Voltar para o login</Text>
          </TouchableOpacity>
        </View>
      )}
    </View>
  );
};

export default DeleteAccountScreen;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#0f2027',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 30,
  },
  title: {
    fontSize: 24,
    fontWeight: 'bold',
    color: '#FF4D4D',
    textAlign: 'center',
    marginBottom: 30,
  },
  input: {
    backgroundColor: '#1f3b4d',
    color: '#fff',
    width: '100%',
    paddingVertical: 12,
    paddingHorizontal: 15,
    borderRadius: 6,
    marginBottom: 15,
    fontSize: 16,
  },
  deleteButton: {
    backgroundColor: '#FF4D4D',
    paddingVertical: 12,
    paddingHorizontal: 25,
    borderRadius: 6,
    marginBottom: 20,
  },
  deleteButtonText: {
    color: '#fff',
    fontWeight: 'bold',
    fontSize: 16,
    textAlign: 'center',
  },
  cancelButton: {
    backgroundColor: '#aaa',
    paddingVertical: 10,
    paddingHorizontal: 20,
    borderRadius: 6,
  },
  cancelButtonText: {
    color: '#fff',
    fontSize: 14,
  },
  confirmation: {
    alignItems: 'center',
  },
  confirmationTitle: {
    color: '#00FF9D',
    fontSize: 20,
    fontWeight: 'bold',
    marginBottom: 10,
  },
  confirmationText: {
    color: '#fff',
    fontSize: 16,
    textAlign: 'center',
    marginBottom: 30,
  },
  backButton: {
    backgroundColor: '#00FF9D',
    paddingVertical: 10,
    paddingHorizontal: 20,
    borderRadius: 6,
  },
  backButtonText: {
    color: '#000',
    fontWeight: 'bold',
    fontSize: 14,
  },
});
